"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Folder = void 0;
var Folder = /** @class */ (function () {
    function Folder() {
        this.name = '';
        this.sequence = 0;
        this.clientId = 0;
        this.parentFolderId = null;
        this.applications = [];
        this.routes = [];
        this.deletedBy = null;
        this.deletedDate = null;
    }
    return Folder;
}());
exports.Folder = Folder;
